import { TimeBlockAbsenceModel } from '../../../core/models/timeblock/time-block.model';
import { TodoEntryModel } from '../../../core/models/todo-planner/todo-entry.model';
import { TimeBlockComponent } from '../../calendar/components/time-block/time-block.component';
import { ITimeBlockComponentItem } from '../../calendar/components/time-block/types/time-block-component-item-types';
import {
  FixInterval,
  TimeBlockContentType,
} from '../../calendar/components/time-block/types/time-block-types';

export class TodoEntryConverter {
  public static toITimeBlockComponentItem(todoEntryModel: TodoEntryModel): ITimeBlockComponentItem {
    const timeBlockAbsenceModel = new TimeBlockAbsenceModel<TimeBlockComponent>();
    timeBlockAbsenceModel.id = todoEntryModel.id;
    timeBlockAbsenceModel.start = todoEntryModel.start;
    timeBlockAbsenceModel.end = todoEntryModel.end;
    timeBlockAbsenceModel.userId = todoEntryModel.userId;
    timeBlockAbsenceModel.timeBlockViewType = todoEntryModel.timeBlockViewType;
    timeBlockAbsenceModel.fixInterval = TodoEntryConverter.toFixInterval(todoEntryModel);

    return {
      timeBlockModel: timeBlockAbsenceModel,
      id: todoEntryModel.id,
      timeBlockContentType: TimeBlockContentType.Absence,
      clone: () => null,
      insertIntoCalendar: () => {},
      removeFromCalendar: () => {},
    };
  }

  // Bit hacky
  private static toFixInterval(todoEntryModel: TodoEntryModel): FixInterval {
    return todoEntryModel.fixInterval ? FixInterval.FullWorkingDay : null;
  }
}
